import { Device } from '@rocksoft/mdm-sdk-v2';

import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

export function selectDeviceId(device: Device) {
  return device.identifier;
}

export const adapter: EntityAdapter<Device> = createEntityAdapter<Device>({
  selectId: selectDeviceId,
});

export type DeviceState = EntityState<Device>;

export const initialState: DeviceState = adapter.getInitialState();
